var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"results-map"},[_c('div',{ref:"map",staticClass:"results-map__map"}),(_vm.api && _vm.map)?[_vm._t("default",null,{"api":_vm.api,"map":_vm.map})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }